import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-0"}],["path",{"d":"M8 13.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-1"}],["path",{"d":"M8 8h8v8","key":"svg-2"}]]

const IconBrandAbstract = createReactComponent('outline', 'brand-abstract', 'BrandAbstract', __iconNode);

export default IconBrandAbstract;